import { useContext } from 'react';

import { ConnectFormContext } from '../ConnectFormContext';

export default function useConnectForm() {
  return useContext(ConnectFormContext);
}
